module.exports = __webpack_public_path__ + "static/media/tuvan.4d8ed24b.png";